import { HttpClient, HttpEvent, HttpHeaders, HttpResponse } from "@angular/common/http";
import { map, Observable, tap } from "rxjs";
import { AuthService } from "./auth.service";
import { AbstractHttpService } from "./http-abstract.service";
import { DynamicEntityDto, DynamicPropertyDto, DynamicTemplateDto } from "./dto";
import { Injectable } from "@angular/core";

@Injectable({
	providedIn: 'root'
})
export class HttpDynamicService extends AbstractHttpService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/dynamic', authService);
	}
	public getTemplates(): Observable<DynamicTemplateDto[]> {
		return super.doGet(true, "/template/");
	}
	public getAll(): Observable<DynamicEntityDto[]> {
		return super.doGet(true, "/");
	}
	public get(id: number): Observable<DynamicEntityDto> {
		return super.doGet(true, `/${id}`);
	}
	public edit(id: number, payload: DynamicEntityDto): Observable<DynamicEntityDto> {
		return super.doPost(true, `/${id}`, payload);
	}
	public checkUnique(propertyId: number, entityId: number | undefined, value: string): Observable<{ unique: boolean }> {
		if (entityId) {
			return super.doPost(true, `/validate/unique/${propertyId}/${entityId}`, value);
		} else {
			return super.doPost(true, `/validate/unique/${propertyId}`, value);
		}
	}
}
